export default __webpack_public_path__ + "static/media/vegetable.e8f53ab6.jpg";